import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-faf971f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "mb-10" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "firstName",
  class: "form-label"
}, "First name", -1))
const _hoisted_4 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_5 = { class: "mb-10" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "lastName",
  class: "form-label"
}, "Last name", -1))
const _hoisted_7 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_8 = { class: "mb-10" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "avatarColor",
  class: "form-label"
}, "Avatar Color", -1))
const _hoisted_10 = { id: "colorPicker" }
const _hoisted_11 = ["id", "onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-sm btn-primary me-3"
}, " Save ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "form",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          name: "firstName",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.firstName) = $event)),
          class: "form-control form-control-solid input-width",
          id: "firstName"
        }, null, 512), [
          [_vModelText, _ctx.state.firstName]
        ]),
        (_ctx.v$.firstName.$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.v$.firstName.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          name: "lastName",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.lastName) = $event)),
          class: "form-control form-control-solid input-width",
          id: "lastName"
        }, null, 512), [
          [_vModelText, _ctx.state.lastName]
        ]),
        (_ctx.v$.lastName.$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.v$.lastName.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors, (color, index) => {
            return (_openBlock(), _createElementBlock("button", {
              type: "button",
              class: "color-picker",
              key: index,
              id: color,
              style: _normalizeStyle(
              `background-color: ${color}; border: ${
                color == _ctx.pickedColor ? '3px solid grey' : 'none'
              }`
            ),
              onClick: ($event: any) => (_ctx.selectColor(color))
            }, null, 12, _hoisted_11))
          }), 128))
        ])
      ]),
      _hoisted_12,
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-sm btn-secondary me-3",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeEdit && _ctx.closeEdit(...args)))
      }, " Cancel "),
      _hoisted_13
    ], 32)
  ]))
}